import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/** Client-side 301-equivalent for old URLs (Firebase Hosting handles external 301s). */
const LegacyRedirect: React.FC<{ to: string }> = ({ to }) => {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}${location.hash}`} replace />;
};

export default LegacyRedirect;
